import axios from "axios";
import apiClient from "./apiClient";
import { getSelectedSport } from "./helpers";

// Basketball sport codes that use the Node.js BigQuery roster endpoint
const BASKETBALL_SPORTS = ['MBB', 'WBB', 'NBA', 'WNBA', 'EURO', 'GL'];

/**
 * Fetch official rosters for college sports (MBB, CBB)
 * - Basketball sports: queries NatStat BigQuery via Node.js backend (same-origin)
 * - Baseball/other sports: queries Python backend directly
 * @param {string} teamName - The team name to search for
 * @returns {Promise<{data: Array}>} - Array of unique players
 */
const getCollegeRosters = async (teamName = '') => {
    let sport = 'MBB'; // Default fallback
    try {
        sport = getSelectedSport() || 'MBB';
        if (!teamName?.length) {
            return [];
        }

        let players = [];

        if (BASKETBALL_SPORTS.includes(sport)) {
            // Basketball: use Node.js backend with NatStat BigQuery data (same-origin)
            const response = await axios.post('/api/basketball/roster/search', {
                team_name: teamName,
                league: sport,
            });
            players = response?.data?.data || [];
        } else {
            // Baseball/other: use Python backend
            const response = await apiClient.post(
                `https://slam-all-python-359065791766.us-central1.run.app/${sport}/official-roasters/search?schema=${sport}`,
                { team_name: teamName }
            );
            players = response?.data?.data || [];
        }

        // Get unique players by player_name
        const uniquePlayers = Array.from(
            new Map(players.map(player => [player?.player_name, player]))?.values()
        );
        return { data: uniquePlayers };
    } catch (error) {
        console.error(`Error searching ${sport} official roster:`, error);
        return [];
    }
};

// Alias for backward compatibility
const getMBBRoasters = getCollegeRosters;

export {
    getMBBRoasters,
    getCollegeRosters
};
